export const cacheKeys = {
  detail: (workspaceId: number) => ['workspaces', workspaceId, 'autoReplyConfig', 'detail'] as const,
  analytics: (workspaceId: number, days: number) =>
    ['workspaces', workspaceId, 'autoReplyConfig', 'analytics', days] as const,
} as const
